import { render, staticRenderFns } from "./RelationshipCodeDetail.vue?vue&type=template&id=078aa155&scoped=true"
import script from "./RelationshipCodeDetail.vue?vue&type=script&lang=js"
export * from "./RelationshipCodeDetail.vue?vue&type=script&lang=js"
import style0 from "./RelationshipCodeDetail.vue?vue&type=style&index=0&id=078aa155&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078aa155",
  null
  
)

export default component.exports